import { fetchRetry } from "./fetch.ts";
import { createLogger } from "./logging.ts";
import { captureErrorWithPayload } from "./error.ts";

const APM_ERROR_KEYS = {
	tag: "ft9-benefit-detailview-activation-failed",
	sheet: "ft9-benefit-sheet-activation-failed",
};

export enum ActivationResponseType {
	Activated = 0,
	Conflict = 1,
	Error = 2,
}

export class ActivationClient {
	async activateByUrl(activationUrl: string, errorLoggingPayload: object, namespace: "tag" | "sheet"): Promise<ActivationResponseType> {
		const log = createLogger(namespace, "activation-client");
		const apmErrorKey = APM_ERROR_KEYS[namespace];
		const fetchOptions: RequestInit = {
			method: "POST",
			headers: { "X-Requested-With": "XMLHttpRequest" },
		};

		log.info(`Call ${activationUrl} to activate benefit using following options: ${JSON.stringify(fetchOptions)}`);

		try {
			const response = await fetchRetry({
				url: activationUrl,
				namespace,
				timeout: 1000,
				fetchOptions,
				retryOptions: {
					limit: 2,
					delay: 500,
				},
			});

			if (!response.ok) {
				const labels = {
					...errorLoggingPayload,
					status_code: response.status,
					response_type: response.type,
					response_ok: response.ok,
					response_headers: JSON.stringify(response.headers),
				};
				captureErrorWithPayload("Response is not OK", namespace, "activation-client", apmErrorKey, response?.status, labels);
			}

			if (response.status === 200) {
				return ActivationResponseType.Activated;
			}
			if (response.status === 409) {
				return ActivationResponseType.Conflict;
			}

			return ActivationResponseType.Error;
		} catch (e: unknown) {
			const labels = {
				...errorLoggingPayload,
				failing_reason: "error",
			};
			captureErrorWithPayload("Activation failed", namespace, "activation-client", apmErrorKey, e, labels);

			return ActivationResponseType.Error;
		}
	}
}
